<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <div>
        <territory-form
          v-if="selectedTerritory"
          :territory="selectedTerritory"
        />
        <v-card>
          <v-card-actions
            v-if="selectedTerritory"
          >
            <v-btn
              v-if="selectedTerritory.id"
              color="darken-1"
              flat
              small
              @click="deleteTerritory"
            >
              {{ $t('Delete territory') }}
            </v-btn>
            <v-spacer />
            <v-btn
              color="darken-1"
              flat
              small
              @click="closeDialog"
            >
              {{ $t('Close') }}
            </v-btn>
            <v-btn
              color="primary darken-1"
              flat
              small
              @click="applyTerritory()"
            >
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>

    <v-flex
      class="d-flex"
    >
      <h3>{{ $t('Territories') }}</h3>
      <v-spacer/>
      <v-btn
        @click="createTerritory"
      >
        {{ $t('Add new territory') }}
      </v-btn>
    </v-flex>
    <div
      v-for="(territory, index) in territories"
      :key="`${territory}-${index}`"
    >
      <v-flex @click="editTerritory(territory)">
        <TerritoryPreview :territory="territory"/>
      </v-flex>
      <v-divider
        v-if="index !== territories.length-1"
      />
    </div>
  </div>
</template>

<script>
import TerritoryForm from './TerritoryForm'
import TerritoryPreview from './TerritoryPreview'
import { pickBy, identity } from 'lodash'

export default {
  name: 'Territories',

  components: {
    TerritoryForm,
    TerritoryPreview
  },

  props: {
    territories: {
      type: Array,
      default: () => []
    },
    zone: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      dialog: false,
      selectedTerritory: null,
      isUpdating: false
    }
  },

  methods: {
    async createTerritory () {
      this.dialog = true
      this.isUpdating = false
      this.selectedTerritory = await this.$http.make('territories', { country_code: '' })
    },

    async editTerritory (territory) {
      this.selectedTerritory = await this.$http.make('territories', territory)
      this.dialog = true
      this.isUpdating = true
    },

    closeDialog () {
      this.dialog = false
      this.isUpdating = false
      this.$emit('updateZoneTerritories')
    },

    async applyTerritory () {
      if (!this.isUpdating) {
        const territory = {
          country_code: this.selectedTerritory.country_code,
          administrative_area: this.selectedTerritory.administrative_area,
          locality: this.selectedTerritory.locality,
          dependent_locality: this.selectedTerritory.dependent_locality,
          included_postal_codes: this.selectedTerritory.included_postal_codes,
          excluded_postal_codes: this.selectedTerritory.excluded_postal_codes
        }
        const cleanedTerritory = pickBy(territory, identity)
        this.selectedTerritory = this.$http.make('territories', cleanedTerritory)
      }
      await this.selectedTerritory.for(this.zone)
        .save()
        .then(() => {
          this.closeDialog()
          this.$radio.$emit('item-saved', { message: this.$t(`Territory saved`) })
        })
        .catch(e => {
          this.$radio.$emit('api-error', { message: this.$t('Validation failed'), errors: this.selectedTerritory.errors })
        })
    },

    async deleteTerritory () {
      await this.selectedTerritory.for(this.zone).delete()
      this.$emit('updateZoneTerritories')
      this.closeDialog()
    }
  }
}
</script>

<style>

</style>
